
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from 'react';
import { GlobalEmptyComponent } from '@/components/common/GlobalComponent';
import { GetServerSideProps } from 'next';
import { getAssetsCdnConfig } from '@weee-fe/module';
import { getHttpReqAwareProps } from '@/utils/http-req-aware-helper';
import { getHelpDetails } from '@/api/cs';
import { getAppStatusBarHeight } from '@/utils/common/device';
import AgreementContent from '@/components/about/AgreementContent';

const HELP_KEY = 2709;

export default function TransparencySupplyChains({ data, barHeight }) {
  return <AgreementContent data={data} />;
}

 const _getServerSideProps: GetServerSideProps = async ctx => {
  let res: AResponse;
  try {
    res = await getHelpDetails({ deskArticleId: HELP_KEY, previewLang: 'en' }, { ctx });
  } catch (error) {
    return { notFound: true };
  }

  return {
    props: {
      data: res?.object || null,
      barHeight: getAppStatusBarHeight(ctx),
      ...getAssetsCdnConfig(ctx),
      ...getHttpReqAwareProps(ctx)
    }
  };
};

TransparencySupplyChains.GlobalComponent = GlobalEmptyComponent;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/about/transparency-supply-chains',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  